import { fillMessageParts } from '@ai-sdk/ui-utils';
/**
 * Persisted / MobX snapshots usually store `toolInvocations` only. The AI SDK's
 * `updateToolCallResult` (used by useChat `addToolResult`) matches tool rows via
 * `message.parts` (`tool-invocation` parts). Without `parts`, addToolResult no-ops.
 * Empty `parts: []` also blocks `getMessageParts` fallback inside fillMessageParts.
 */
export function normalizeMessagesForAddToolResult(messages) {
    const stripped = messages.map((m) => {
        const raw = m;
        const ti = raw.toolInvocations;
        const parts = raw.parts;
        if (Array.isArray(ti) && ti.length > 0 && Array.isArray(parts) && parts.length === 0) {
            const { parts: _drop, ...rest } = raw;
            return rest;
        }
        return m;
    });
    const withToolCallId = stripped.map((m) => {
        const raw = m;
        if (!raw.toolInvocations?.length)
            return m;
        let changed = false;
        const toolInvocations = raw.toolInvocations.map((invRaw) => {
            const inv = invRaw;
            const idAlt = typeof inv.id === 'string' ? inv.id : undefined;
            const tcid = (typeof inv.toolCallId === 'string' ? inv.toolCallId : undefined) ?? idAlt;
            if (typeof tcid !== 'string' || tcid.length === 0)
                return invRaw;
            if (inv.toolCallId === tcid)
                return invRaw;
            changed = true;
            return { ...inv, toolCallId: tcid };
        });
        if (!changed)
            return m;
        return { ...m, toolInvocations };
    });
    return fillMessageParts(withToolCallId);
}
//# sourceMappingURL=normalizeMessagesForAddToolResult.js.map